(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('painelEdicaoAdubacao', PainelEdicaoAdubacao);

  function PainelEdicaoAdubacao() {
    return {
      restrict: 'E',
      templateUrl: 'views/painel_propriedade/adubacao/_edicao.html',
      controller: 'AdubacaoCtrl'
    };
  }

}());
